import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const ProtectedRoute = () => {
  const { account, isLoadingAuth } = useAuth();

  if (window.__E2E_TEST__) {
    return <Outlet />;
  }

  if (isLoadingAuth) {
    return null;
  }

  if (!account) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
